import { Formik } from "formik";
import { Divider, Grid, TextField, FormLabel, Select, MenuItem , Autocomplete} from "@mui/material";
import { useEffect, useState } from "react";
import { Modal } from "../../../components/common/Modal/Modal";
import { ModalHeader } from "../../../components/common/Modal/ModalHeader";
import { ModalBody } from "../../../components/common/Modal/ModalBody";
import { ModalFooter } from "../../../components/common/Modal/ModalFooter";
import { useStoreStore } from "../../../hooks/useStoreStore";
import { useBranchOfficeStore } from "../../../hooks/useBranchOfficeStore";

type Values = {
    id: number,
    idtools: any,
    cuotas: string,
    idcuotas: any,
    idway_to_pay:number,
    wayToPay: string,
    idcompany:number,
    status: string,
}

const states = [
    {name: 'Activo', value: '1'},
    {name: 'Desactivo', value: '0'},
]

export const WayToPayByCompanyModal: React.FC<any> = (props): JSX.Element | any => {

    const { open, closeModal, waytopaySelected, listWaytopay, clearState } = props;

    const { action, createStore, editStore } = useStoreStore();
    const { getBranchOffice } = useBranchOfficeStore();

    const [loading, setLoading] = useState(false);
    const [loadingdata, setLoadingdata] = useState(false);
    const [branchOffices, setBranchOffices] = useState<any>([]);
    const [branchOfficeSelected, setBranchOfficeSelected] = useState<any>('');
    const [data, setData] = useState<Values>({
        id: waytopaySelected ? waytopaySelected.id :'',
        idtools: waytopaySelected ? waytopaySelected.idtools :'',
        cuotas: waytopaySelected ? waytopaySelected.cuotas :'',
        idcuotas: waytopaySelected ? waytopaySelected.idcuotas :'',
        idway_to_pay: waytopaySelected ? waytopaySelected.idway_to_pay :'',
        wayToPay: waytopaySelected ? waytopaySelected.wayToPay :'',
        idcompany: waytopaySelected ? waytopaySelected.idcompany :'',
        status: waytopaySelected ? waytopaySelected.status :'1',
    });

    useEffect(() => {
        getBranchOfficeApi()
    },[])

    useEffect(() => {
        if(waytopaySelected && branchOffices){
            setCustomBranchOffice(waytopaySelected.idbranchoffice, branchOffices)
        }
    },[waytopaySelected, branchOffices])

    const setCustomBranchOffice = (idbranchoffice, branchOffices) => {
        const data = branchOffices.find(branch => branch.id == idbranchoffice);
        return setBranchOfficeSelected(data);
    }

    const getBranchOfficeApi = async(search='') => {
        try {
            setLoadingdata(true);
            const response = await getBranchOffice(search);
            if(!response){
                setBranchOffices([]);
                setLoadingdata(false);
                return false;
            }else{
                console.log(response)
                setBranchOffices(response || []);
                setLoadingdata(false);
            }
        } catch (error) {
            setLoadingdata(false);
        }
    }

    const validateForm = (values) => {
        let errors:any = {};
        if(!values.code) errors.code = "el campo es requerido";
        if(!values.name) errors.name = "el campo es requerido";
        if(!values.idbranchoffice) errors.idbranchoffice = "el campo es requerido";
        return errors;
    }

    const onSubmit = async(values)  => {
        setLoading(true);

        if(waytopaySelected){
            const response:any = await editStore(waytopaySelected.id, values);
            if(response){
                listWaytopay && listWaytopay();
                closeModal && closeModal();
                clearState && clearState();
                setLoading(false);
            }else{
                setLoading(false);
                return false;
            }
        }else{
            const response:any = await createStore(values);
            if(response){
                listWaytopay && listWaytopay();
                closeModal && closeModal();
                clearState && clearState();
                setLoading(false);
            }else{
                setLoading(false);
                return false;
            }
        }
    }

    return (
        <Modal open={open} handleClose={closeModal} disableEscapeKeyDown disableBackdropClick handle size="md" paperprops={{style: { position: 'absolute', right: -30, borderRadius: 20, animation: 'slide-in 0.3s ease-out' }}}>
            <ModalHeader
                text={
                    action == 'edit' ? 'Editar bodega' : (action == 'add' ? 'Nueva bodega' : 'Detalle de la bodega')
                }
                className='positionElements'
                onCancel={closeModal}
                clearState={clearState}
            >
            </ModalHeader>
            <ModalBody>
                <Formik initialValues={data} enableReinitialize validate={ (values) => validateForm(values) } onSubmit={onSubmit}>
                    {({values, errors, touched, handleSubmit, handleChange, setFieldValue}) => {
                        return (
                            <form onSubmit={handleSubmit}>
                                <Grid container sx={{padding:'20px'}}>
                                    <Grid item container xs={12} spacing={2}>
                                        <Grid item xs={12} md={6}>
                                            <FormLabel>Forma de pago:</FormLabel>
                                            <TextField
                                                id="wayToPay"
                                                type="text" 
                                                name="wayToPay"
                                                fullWidth
                                                size="small"
                                                value={values.wayToPay}
                                                onChange={handleChange}
                                                error={errors.wayToPay && touched.wayToPay ? true : false}
                                                helperText={errors.wayToPay && touched.wayToPay ? errors.wayToPay : ''}
                                                inputProps={{ readOnly: action == 'detail' }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <FormLabel>Herramientas de pago:</FormLabel>
                                            {/* <Autocomplete
                                                multiple
                                                id="combo-box-demo"
                                                value={values.idtools || []}
                                                options={customCompanies || []}
                                                getOptionLabel={(option) => option.name || ""}
                                                fullWidth
                                                renderInput={(params) => <TextField {...params}  />}
                                                onChange={(e, newValue) => {
                                                    setFieldValue("idtools", newValue);
                                                }}
                                                size="small"
                                            /> */}
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <FormLabel>Estado:</FormLabel>
                                            <Select
                                                id="status"
                                                value={values.status}
                                                size="small"
                                                onChange={(event) => { 
                                                    setFieldValue("status", event.target.value);
                                                }}
                                                error={ errors.status && touched.status ? true : false }
                                                fullWidth
                                                inputProps={{ readOnly: action == 'detail' }}
                                            >
                                                {
                                                    states.map((state, i) => {
                                                        return <MenuItem key={i} value={state.value}>{state.name}</MenuItem>;
                                                    })
                                                }
                                            </Select>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Divider />
                                {
                                    action != 'detail' && (
                                        <ModalFooter 
                                            buttonType="submit"
                                            confirmText={'Guardar'}
                                            onConfirm={handleSubmit}
                                            cancelText={"Cancelar"}
                                            onCancel={closeModal}
                                            loadingConfirmText={loading}
                                            clearState={clearState}
                                        />
                                    )
                                }
                                
                            </form>
                        )
                    }} 
                </Formik>
            </ModalBody>
        </Modal>
    )
}